import { render, staticRenderFns } from "./selectTopic.vue?vue&type=template&id=be48fd04&scoped=true"
import script from "./selectTopic.vue?vue&type=script&lang=js"
export * from "./selectTopic.vue?vue&type=script&lang=js"
import style0 from "@/styles/pc.css?vue&type=style&index=0&id=be48fd04&prod&scoped=true&lang=css&external"
import style1 from "./selectTopic.vue?vue&type=style&index=1&id=be48fd04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be48fd04",
  null
  
)

export default component.exports